import React from 'react';
import { Anchor } from 'lucide-react';
import NewsletterSignup from './NewsletterSignup';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1a1c1b] border-t border-[#3f4816] py-12">
      <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
        {/* Newsletter signup */}
        <div className="mb-10">
          <NewsletterSignup source="footer" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <Anchor className="text-[#d9fb06]" size={32} />
              <h3 className="text-2xl font-black text-[#d9fb06]">validatedboat</h3>
            </div>
            <p className="text-[#888680] mb-4 max-w-md">
              Conseiller nautique indépendant spécialisé dans l'accompagnement à l'achat de bateaux. 20 ans d'expérience au service de votre sérénité.
            </p>
            <p className="text-[#d9fb06] font-semibold">
              Aide à construire un achat serein
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#d9fb06] font-bold mb-4 uppercase">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-[#888680] hover:text-[#d9fb06] transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-[#888680] hover:text-[#d9fb06] transition-colors">
                  Pourquoi nous
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-[#888680] hover:text-[#d9fb06] transition-colors">
                  Tarifs
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-[#888680] hover:text-[#d9fb06] transition-colors">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-[#d9fb06] font-bold mb-4 uppercase">Contact</h4>
            <ul className="space-y-2 text-[#888680]">
              <li>contact@validatedboat.fr</li>
              <li className="font-semibold text-[#dfddd6]">La Rochelle</li>
              <li>France métropolitaine</li>
              <li>Sur rendez-vous</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#3f4816] flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-[#888680] text-sm">
            © {new Date().getFullYear()} validatedboat. Tous droits réservés.
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm justify-center md:justify-end">
            <a href="/mentions-legales" className="text-[#888680] hover:text-[#d9fb06] transition-colors">
              Mentions légales
            </a>
            <a href="/methode-validatedboat" className="text-[#888680] hover:text-[#d9fb06] transition-colors" data-testid="footer-methode-link">
              La méthode
            </a>
            <a href="/politique-confidentialite" className="text-[#888680] hover:text-[#d9fb06] transition-colors" data-testid="footer-privacy-link">
              Politique de confidentialité
            </a>
            <a href="/politique-cookies" className="text-[#888680] hover:text-[#d9fb06] transition-colors" data-testid="footer-cookies-link">
              Politique cookies
            </a>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new CustomEvent('open-cookie-preferences'))}
              className="text-[#888680] hover:text-[#d9fb06] transition-colors"
              data-testid="footer-manage-cookies-btn"
            >
              Gérer mes cookies
            </button>
            <a href="/exercer-mes-droits" className="text-[#888680] hover:text-[#d9fb06] transition-colors" data-testid="footer-rgpd-link">
              Mes droits RGPD
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;